<script>
import BFormCheckboxRadio from '@/components/form/base/BFormCheckboxRadio'

export default {
  name: 'CFormCheckbox',

  extends: BFormCheckboxRadio,

  props: {
    falseValue: {
      type: [Array, Date, Boolean, Number, String],
      default: false
    },
    modelValue: {
      type: [Array, Date, Boolean, Number, String],
      default: false
    },
    trueValue: {
      type: [Array, Date, Boolean, Number, String],
      default: true
    }
  },

  data () {
    return {
      type: 'checkbox'
    }
  },

  computed: {
    checked () {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }

      return this.modelValue === this.trueValue
    }
  },

  methods: {
    onChange (event) {
      let isChecked = event.target.checked

      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]

        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }

        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
}
</script>
